<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>Edit team roles</h3>

    <div adapt-dialog-content>
        <adapt-team-roles [team]="team"
                          [isEditing]="true"
                          [nested]="true"></adapt-team-roles>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="close"
                                   [hideCancelButton]="true"
                                   (saveClick)="resolve()"></adapt-standard-dialog-buttons>
</adapt-dialog>

<adapt-context-sidebar-content context="dialog">
    <h2 context-sidebar-title>Team roles</h2>

    <p>Understanding the roles your <b>team</b> performs, as well as who is accountable for those roles,
        helps to answer the question <i>'Who does what on this team?'</i>.</p>

    <hr>
    <h4>Assigning people to a role</h4>
    <p>You can assign a person to a specific role by dragging the person to the <b>Drop person here</b> area within the
        role.</p>

    <h4>Pinning roles to the team</h4>
    <p>You can pin existing roles to the team by clicking the <b>Pin existing roles to team</b> button,
        then selecting the roles you would like to be visible within the team.</p>

    <h4>Adding new roles</h4>
    <p>You can create a new role within the platform by clicking the <b>Create new role</b> button,
        then giving the role a name.</p>
</adapt-context-sidebar-content>
